// extracted by mini-css-extract-plugin
module.exports = {"section":"CA_section__5pNG0"};